import { render, staticRenderFns } from "./link_page.vue?vue&type=template&id=59b0f92c"
import script from "./link_page.vue?vue&type=script&lang=js"
export * from "./link_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports